import type { FaireProductEntity } from "../../entity_types/product";

export const p_hw3da87pv7: FaireProductEntity = {
  token: "p_hw3da87pv7",
  type: "product",
  name: "Not Fade Away® Color Safe Shampoo",
  brandToken: "b_6cng0pthbr",
  brandName: "Manic Panic",
  imageUrl:
    "https://cdn.faire.com/fastly/d0cde847979773d505a9652166c4666b68b03672e33d0b9591b43bb99e90ab5f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b5fb9eb697a2e1bcee95ba56a33a55ee249651892883abde45ee3ca4d9313b03.jpeg",
  ],
  priceDollars: 8.75,
  description:
    "Not Fade Away® Color Safe Shampoo is a gentle, sulfate-free cleanser formulated to protect vibrancy and reduce color fade. Designed as Step 2 of the 3-Step Color Care System for ongoing color maintenance. Part of the Manic Panic color care system.\n\nKey Benefits\n💜 Gently cleanses while protecting color vibrancy\n💜 Helps reduce premature color fade\n💜 Sulfate-free formula supports longer-lasting color\n💜 pH-balanced for color-treated hair\n💜 Boosts softness and shine\n💜 Suitable for routine color care use\n\nHow It Works\n💜 Cleanses without stripping deposited color\n💜 Maintains balanced pH for color longevity\n💜 Supports moisture and surface smoothness\n\nKey Ingredients\n💜 Sunflower Seed Extract. Adds moisture and shine\n💜 Color-safe cleansing base. Reduces stripping\n💜 Conditioning support agents. Improve softness\n💜 pH-balanced system. Designed for treated hair\n\nWho It’s For\n💜 Semi-permanent color users maintaining vibrancy\n💜 Bright fashion color wearers reducing fade\n💜 Treated hair customers needing gentle cleansing\n💜 Routine washers protecting bold shades\n\nItem Info\n💜 Size 8 oz / 236 mL\n💜 U.S. Dimensions 2 × 2 × 7.88 in. Weight 0.60 lb\n💜 Metric Dimensions 5.08 × 5.08 × 20 cm. Weight 0.27 kg",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:59.299Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
